import AdRrl from '@/view/adUrl'
const AdRrlComponent = {
  name: 'adUrl',
  component: AdRrl,
  meta: {
    title: '灵芝问诊'
  }
}
export default AdRrlComponent
